import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kws-error"},[_c('span',[_c('b',[_vm._t("default")],2)]),_c(VBtn,{attrs:{"icon":"","fab":"","small":"","color":"primary"},on:{"click":function($event){return _vm.$emit('reload', $event)}}},[_c(VIcon,[_vm._v("refresh")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }